import React, { useState, useEffect } from 'react';
import { Card, Table, Input, Tag, Typography, Statistic, Row, Col, Space } from 'antd';
import { SearchOutlined, UserOutlined, DollarOutlined, MailOutlined } from '@ant-design/icons';
import { agentAPI } from '../services/api';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

export default function UserList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [pagination, setPagination] = useState({ page: 1, pageSize: 20 });

  useEffect(() => { loadUsers(); }, [pagination.page, pagination.pageSize, keyword]);

  const loadUsers = async () => {
    setLoading(true);
    try {
      const res = await agentAPI.getUsers({ page: pagination.page, page_size: pagination.pageSize, keyword });
      setData(res.data.list || []);
      setTotal(res.data.total || 0);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70, align: 'center' },
    {
      title: '邮箱', dataIndex: 'email', key: 'email', width: 200,
      render: (text) => text ? (
        <Space><MailOutlined style={{ color: '#999' }} /><Text>{text}</Text></Space>
      ) : <Tag color="default">未设置</Tag>,
    },
    {
      title: '手机号', dataIndex: 'phone', key: 'phone', width: 150,
      render: (text) => text || <Tag color="default">未设置</Tag>,
    },
    {
      title: '注册时间', dataIndex: 'register_time', key: 'register_time', width: 160,
      render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm'),
      sorter: (a, b) => dayjs(a.register_time).unix() - dayjs(b.register_time).unix(),
    },
    {
      title: '余额', dataIndex: 'balance', key: 'balance', width: 120, align: 'right',
      render: (v) => <Text strong>¥{parseFloat(v || 0).toFixed(2)}</Text>,
      sorter: (a, b) => (a.balance || 0) - (b.balance || 0),
    },
    {
      title: '累计消费', dataIndex: 'total_consumption', key: 'total_consumption', width: 140, align: 'right',
      render: (v) => <Tag color="blue" style={{ fontSize: 13 }}>¥{parseFloat(v || 0).toFixed(2)}</Tag>,
      sorter: (a, b) => (a.total_consumption || 0) - (b.total_consumption || 0),
    },
  ];

  const totalConsumption = data.reduce((s, u) => s + parseFloat(u.total_consumption || 0), 0);
  const totalBalance = data.reduce((s, u) => s + parseFloat(u.balance || 0), 0);

  return (
    <div>
      <Row gutter={[20, 20]} style={{ marginBottom: 20 }}>
        <Col xs={24} sm={8}>
          <Card bordered={false} className="kpi-card" style={{ borderRadius: 14, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <Statistic title={<Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13 }}>本站用户总数</Text>}
              value={total} prefix={<UserOutlined />} valueStyle={{ color: '#fff', fontSize: 28, fontWeight: 700 }} />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card bordered={false} className="kpi-card" style={{ borderRadius: 14, background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
            <Statistic title={<Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13 }}>累计消费总额</Text>}
              value={totalConsumption} precision={2} prefix={<DollarOutlined />} suffix="元" valueStyle={{ color: '#fff', fontSize: 28, fontWeight: 700 }} />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card bordered={false} className="kpi-card" style={{ borderRadius: 14, background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
            <Statistic title={<Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13 }}>用户总余额</Text>}
              value={totalBalance} precision={2} prefix={<DollarOutlined />} suffix="元" valueStyle={{ color: '#fff', fontSize: 28, fontWeight: 700 }} />
          </Card>
        </Col>
      </Row>

      <Card bordered={false} style={{ borderRadius: 14 }}
        title={<Title level={5} style={{ margin: 0 }}>用户列表</Title>}
        extra={
          <Input.Search placeholder="搜索邮箱或手机号" allowClear
            onSearch={(v) => { setKeyword(v); setPagination(p => ({ ...p, page: 1 })); }}
            style={{ width: 280 }} />
        }>
        <Table columns={columns} dataSource={data} rowKey="id" loading={loading}
          pagination={{
            current: pagination.page, pageSize: pagination.pageSize, total, showSizeChanger: true,
            showTotal: (t) => `共 ${t} 位用户`,
            onChange: (page, pageSize) => setPagination({ page, pageSize }),
          }} />
      </Card>
    </div>
  );
}
